<template>
  <v-autocomplete
    :items="stores"
    item-text="name"
    item-value="id"
    @change="handleSelect"
    :loading="loading"
    :value="store"
    :search-input.sync="filter"
    placeholder="Selecione uma loja"
    clearable
    cache-items
    return-object
    v-bind="$props"
  ></v-autocomplete>
</template>

<script>
import { index as indexStores } from '@/services/stores';
export default {
  name: "store-select",
  props: {
    store: Object,
    label: String,
    clearable: Boolean,
    "error-messages": Array,
    name: String,
    autofocus: Boolean
  },
  model: {
    prop: "store",
    event: "change"
  },
  data: () => ({
    loading: false,
    filter: null,
    stores: []
  }),
  methods: {
    handleSelect(value) {
      this.$emit("change", value);
      this.loading = false;
    },
    async getStores() {
      this.loading = true;
      try {
        const response = await indexStores({ filter: this.filter, list: true });
        this.stores = response;
      } catch (e) {
        console.log('Falha ao carregar lojas');
      } finally { 
        this.loading = false;
      }
    }
  },
  created() {
    if (this.store?.id)
      this.stores = [this.store];
  },
  watch: {
    filter(val) {
      val && val !== this.store?.name && this.getStores(val)
    },
  }
};
</script>